import { temporaryLoyaltyDomainStore } from '../../temporary-store/store';
export const isMemberSignedIn = () => temporaryLoyaltyDomainStore.data.isMemberSignedIn;
//# sourceMappingURL=is-member-signed-in.js.map